import { render, staticRenderFns } from "./editTable.vue?vue&type=template&id=770835bc&"
import script from "./editTable.vue?vue&type=script&lang=ts&"
export * from "./editTable.vue?vue&type=script&lang=ts&"
import style0 from "./editTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports